import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import Image from "react-bootstrap/Image";
import ArrowTooltips from "../../../../reusableComponents/ToolTipComponent/ToolTipComponent";

export const ReportsLiveChart = ({
  iconImage,
  altText,
  titleText,
  imageClass,
  headingText,
  paragraphText,
  now,
  progressBar,
  tooltipTitle,
}) => {
  return (
    <React.Fragment>
      <div className="main-progress-bar">
        <div className="main-progress-bar-sectionone">
          <div className="d-flex align-items-center">
            <Image
              src={iconImage}
              alt={altText}
              title={titleText}
              fluid
              className={imageClass}
            />
            <h5>{headingText}</h5>
          </div>
         
        </div>
        
        <ArrowTooltips
          title={tooltipTitle || ``}
          open={true}
          display={<ProgressBar now={now} className={progressBar} />}
          now={now}
        />
             <p style={{textAlign:'end',fontSize:"10px",color:'#9E9E9E'}} >{paragraphText}</p>
      </div>
 
    </React.Fragment>
  );
};
